'use strict';

// Subscribe
$('.subscribe-form').on('submit', function (e) {
  e.preventDefault();
  const _action = $(this).attr('action');
  const _token = $('meta[name=csrf_token]').attr('content');
  const _email = $(this).find('input[name=email]').val();
  $('.subscribe-form-messages').html('');
  $.ajax({
    type: 'POST',
    url: _action,
    data: { _token: _token, email: _email },
    dataType: 'json',
    success: (res) => {
      $('.subscribe-form-messages').html(`<div class="form-text text-success">(*) Đăng ký thành công.</div>`);
      window.location.href = res.data;
    },
    error: (err) => {
      if (err.status == 422) {
        const errMsg = err.responseJSON;
        errMsg.forEach((msg) => {
          $('.subscribe-form-messages').append(`<div class="form-text text-danger">(*) ${msg}</div>`);
        });
      } else {
        alert('Không thể thực hiện lúc này. Vui lòng thử lại sau.');
      }
    },
  });
  return false;
});
